import { render, staticRenderFns } from "./termineh.modal.vue?vue&type=template&id=3146b6ce&lang=html&"
import script from "./termineh.modal.vue?vue&type=script&lang=js&"
export * from "./termineh.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports